export enum PrinterStatus {
  Offline = 0,
  Online = 1,
  Start = 2,
  End = 3,
  Pause = 4,
  Cancel = 5,
  Setup = 6,
  Sleep = 7,
}

export enum PrinterActionStatus {
  OnlineNow = 0,
  ReadyToQueue = 1,
  Offline = 2,
  Incompatible = 3,
  Unknown = 4,
}

export enum PrinterStatusExtraInfo {
  ReadyToPrint = 0,
}
